import React, { useEffect } from "react"
import types from "prop-types"
import { store } from "store"
import * as API from "services/api"
import { SideTabs } from "shared/tabs"
import { setGroups, setUsers } from "reduxSlices/categorySlice"
import {
  CATEGORY_ACCESS_TAB_SLUG,
  CATEGORY_ACTIONS_TAB_SLUG,
  CATEGORY_DELETED_SUBMISSIONS_TAB_SLUG,
  CATEGORY_FORM_BUILDERS_TAB_SLUG,
  CATEGORY_FORMS_ORDER_TAB_SLUG,
  CATEGORY_GENERAL_TAB_SLUG,
  CATEGORY_REPORTING_FIELDS_TAB_SLUG,
  CATEGORY_SUBMISSION_STATUSES_TAB_SLUG,
} from "utils/tabSlugHelpers"
import GeneralTab from "./GeneralTab"
import ActionsTab from "./ActionsTab"
import AccessTab from "./AccessTab"
import SubmissionStatusesTab from "./SubmissionStatusesTab"
import FormBuildersTab from "./FormBuildersTab"
import FormsOrderTab from "./FormsOrderTab"
import ReportableFieldsTab from "./ReportableFieldsTab"
import DeletedSubmissionsTab from "./DeletedSubmissionsTab"

const TABS = (tabProps) => [{
  title: "General",
  slug: CATEGORY_GENERAL_TAB_SLUG,
  TabContent: GeneralTab,
  props: tabProps,
}, {
  title: "Actions",
  slug: CATEGORY_ACTIONS_TAB_SLUG,
  TabContent: ActionsTab,
  props: tabProps,
}, {
  title: "Access",
  slug: CATEGORY_ACCESS_TAB_SLUG,
  TabContent: AccessTab,
  props: tabProps,
}, {
  title: "Submission Statuses",
  slug: CATEGORY_SUBMISSION_STATUSES_TAB_SLUG,
  TabContent: SubmissionStatusesTab,
  props: tabProps,
}, {
  title: "Form Builders",
  slug: CATEGORY_FORM_BUILDERS_TAB_SLUG,
  TabContent: FormBuildersTab,
  props: tabProps,
},
{
  title: "Forms Order",
  slug: CATEGORY_FORMS_ORDER_TAB_SLUG,
  TabContent: FormsOrderTab,
  props: tabProps,
},
{
  title: "Reporting Fields",
  slug: CATEGORY_REPORTING_FIELDS_TAB_SLUG,
  TabContent: ReportableFieldsTab,
  props: tabProps,
},
{
  title: "Deleted Submissions",
  slug: CATEGORY_DELETED_SUBMISSIONS_TAB_SLUG,
  TabContent: DeletedSubmissionsTab,
  props: tabProps,
}]

const CategoryTabs = ({ tabProps }) => {
  useEffect(() => {
    (async function getUsers() {
      const response = await API.activityHubOrganizationUsers({ active: true })

      if (response.ok) {
        store.dispatch(setUsers(response.data))
      } else {
        console.error("Error fetching users: ", response)
      }
    }())
  }, [])

  useEffect(() => {
    (async function getGroups() {
      const response = await API.getGroups()

      if (response.ok) {
        store.dispatch(setGroups(response.data))
      } else {
        console.error("Error fetching groups: ", response)
      }
    }())
  }, [])

  return (
    <SideTabs tabs={TABS(tabProps)} />
  )
}

CategoryTabs.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  tabProps: types.object.isRequired,
}

export default CategoryTabs
